/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import { Link } from "../components";

// `/product?sku=${link}`
export default ({ link, children }) => {
  return <Link to={`/product/${link}`}>{children}</Link>;
};
